// extracted by mini-css-extract-plugin
export default {"content":"index_content_6xrKp","clear_20":"index_clear_20_3XYOl"};